import axios from 'axios'

export default {
  async triggerDevice(deviceIp) {
    try {
      if (!deviceIp) {
        throw new Error('Device IP is required')
      }

      // console.log('[Device Trigger] Starting trigger attempt for device:', deviceIp)

      // Create a separate axios instance for device calls since they go directly to the device
      // Device IP from database already includes protocol (http:// or https://)
      const deviceAxios = axios.create({
        baseURL: deviceIp, // deviceIp already includes protocol
        timeout: 2000, // 2 second timeout
        headers: {
          'Access-Control-Allow-Origin': '*', // Allow CORS for device communication
        },
      })

      // console.log('[Device Trigger] Sending request to:', `${deviceIp}/trigger`)
      await deviceAxios.get('/trigger')
      // Note: Response logging removed as it wasn't being used
      return { success: true }
    } catch (error) {
      // console.error('[Device Trigger] Operation failed:', {
      //   deviceIp,
      //   errorType: error.name,
      //   errorMessage: error.message,
      //   stack: error.stack,
      // })
      return {
        success: false,
        error: error?.message || 'Unknown error occurred',
      }
    }
  },
}
